import Error from "../components/errors/Error";
import Layout from "../layout/Layout";
const ErrorPage = () => {
  return (
    <Layout>
      <Error />
    </Layout>
  );
};

export default ErrorPage;
